import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconColors, IconSizes, IrisIconComponent } from '@sondermind/iris/icon';

import { SessionTaskStatus, SessionTaskType } from '../session-task-types';

@Component({
  selector: 'session-task-base',
  imports: [CommonModule, IrisIconComponent],
  templateUrl: './session-task-base.component.html',
  styleUrl: './session-task-base.component.scss'
})
export class SessionTaskBaseComponent {
  readonly taskType = input<SessionTaskType>(SessionTaskType.ACCOUNT_INFO);
  readonly isCompleted = input<boolean>(false);
  readonly isUrgent = input<boolean>(false);
  readonly count = input<number>(0, { alias: 'numberRemaining' });

  iconColors = IconColors;
  iconSizes = IconSizes;
  sessionTaskStatus = SessionTaskStatus;
  sessionTaskType = SessionTaskType;

  readonly taskStatus = computed(() => {
    if (this.isCompleted()) return SessionTaskStatus.COMPLETED;
    if (this.isUrgent()) return SessionTaskStatus.URGENT;
    return SessionTaskStatus.PENDING;
  });

  readonly title = computed<string>(() => {
    switch (this.taskType()) {
      case SessionTaskType.ACCOUNT_INFO:
        return 'Complete account setup';
      case SessionTaskType.DOCUMENTS:
        return 'Sign documents';
      case SessionTaskType.ASSESSMENTS:
        return 'Complete assessments';
      default:
        return '';
    }
  });

  readonly description = computed<string>(() => {
    if (this.taskStatus() === SessionTaskStatus.COMPLETED) {
      return 'Completed';
    }

    switch (this.taskType()) {
      case SessionTaskType.ACCOUNT_INFO:
        return 'Important: Complete 24 hours before  to avoid your session being cancelled';
      case SessionTaskType.DOCUMENTS:
        return `${this.count()} left for this provider`;
      case SessionTaskType.ASSESSMENTS:
        return `${this.count()} left for your providers`;
      default:
        return '';
    }
  });
}
